<script lang="ts" setup>
import Dialog from '@/components/dialog/dialog-modal/dialog.vue'
import { useLinkUrl } from '~/composable/utils/use-link-url'
import { useCommonEvent } from '~/composable/utils/use-common-event'
import { HeadCopyListItem } from '~/api/types/goods'

export interface Props {
  headCopy?: Array<HeadCopyListItem> | null
}

const props = withDefaults(defineProps<Props>(), {})

const { callEvent } = useCommonEvent()
const linkUrl = useLinkUrl()

const dialogRef = ref<InstanceType<typeof Dialog>>()

const headCopyLink = computed(() => {
  if (props.headCopy) {
    return props.headCopy.filter((v: { hdcpEpsuType: string }) => v.hdcpEpsuType === 'LINK_URL')
  }
})

const headCopyCoupon = computed(() => {
  if (props.headCopy) {
    return props.headCopy.filter((v: { hdcpEpsuType: string }) => v.hdcpEpsuType === 'DOWNLOAD')
  }
})

async function _onClickCoupon(offerId: string): Promise<void> {
  callEvent(offerId, dialogRef.value)
}
</script>
<template>
  <div class="head-copy-coupon-wrap">
    <div class="inner" v-for="item in headCopyLink" :key="item.hdcpEpsuType">
      <component
        class="coupon-link"
        :is="'router-link'"
        :type="'button'"
        :to="item?.linkUrl ? { path: linkUrl.getLinkUrl(item) } : undefined"
      >
        <span class="head-copy-text">
          {{ item.textCtnt }}
        </span>
      </component>
    </div>

    <div class="inner" v-for="item in headCopyCoupon" :key="item.hdcpEpsuType">
      <component
        :class="['coupon-down', { event: item.compntNm }]"
        :is="'button'"
        :type="'button'"
        :to="undefined"
        @click="_onClickCoupon(item.offerIdfr)"
      >
        <span class="head-copy-text">
          {{ item.textCtnt }}
        </span>
        <span class="haed-copy-btn">
          {{ item.compntNm !== null ? item.compntNm : '쿠폰 받기' }}
        </span>
      </component>
    </div>
  </div>
  <Dialog ref="dialogRef" />
</template>
<style lang="scss">
@use '~/pages/goods/scss/head-copy-coupon.scss';
</style>
